/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Side_PortalInputs */

const cs_pm_side_portal = /** @type {(inputs: Pm_Side_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portál`)
};

const en_pm_side_portal = /** @type {(inputs: Pm_Side_PortalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal`)
};

/**
* | output |
* | --- |
* | "Portal" |
*
* @param {Pm_Side_PortalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_side_portal = /** @type {((inputs?: Pm_Side_PortalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Side_PortalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_side_portal(inputs)
	return cs_pm_side_portal(inputs)
});